import * as React from 'react';
import { SidebarTrigger } from './ui/sidebar';

interface V2MobileNavProps {
  title?: string;
}

export function V2MobileNav({ title }: V2MobileNavProps) {
  return (
    <div className="flex md:hidden items-center gap-3 px-4 py-3 border-b border-border bg-background shrink-0">
      <SidebarTrigger className="size-9 border border-border" />
      {title && (
        <span className="text-lg font-bold text-foreground truncate">
          {title}
        </span>
      )}
    </div>
  );
}
